module.exports = __webpack_public_path__ + "img/fail.94d69b52.png";